import { motion } from 'framer-motion';
import { useState, useEffect } from 'react';
import { CgAttachment } from "react-icons/cg";
import { useAuthContext } from '../../../hooks/useAuthContext';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function EditInfo() {
  const { auth, dispatch } = useAuthContext();
  const [isLoading, setIsLoading] = useState(true);
  const [fullName, setFullName] = useState(auth?.user?.fullName || "");
  const [phone, setPhone] = useState(auth?.user?.phone || "");
  const [droppedImage, setDroppedImage] = useState(null);
  const [droppedCover, setDroppedCover] = useState(null);

  useEffect(() => {
    if (auth?.user) {
      setFullName(auth.user.fullName);
      setPhone(auth.user.phone);
      setIsLoading(false);
    }
  }, [auth]);

  const handleDrop = (e, type) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files.length) {
      if (type === "image") setDroppedImage(files[0]);
      if (type === "cover") setDroppedCover(files[0]);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleFileChange = (e, type) => {
    if (type === "image") setDroppedImage(e.target.files[0]);
    if (type === "cover") setDroppedCover(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('fullName', fullName);
    formData.append('phone', phone);
    if (droppedImage) formData.append('image', droppedImage);
    if (droppedCover) formData.append('cover', droppedCover);

    try {
      const response = await axios.put(process.env.REACT_APP_API_URL + 'mandoub/edit?scope=basic', formData,{
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('authMandoub'))?.token}`,
        },
      });

      if (response.data) {
        dispatch({ type: 'LOGIN', payload: { ...auth, user: response.data.mandoub } });
        toast.success('تم تحديث المعلومات بنجاح!');
      }

    } catch (error) {
      console.error(error);
      toast.error('حدث خطأ أثناء تحديث معلوماتك.');
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!auth?.user) {
    return <div>Please log in to edit your profile.</div>;
  }

  return (
    <>
      <ToastContainer />
      <form onSubmit={handleSubmit}>
        <div className="df-c">
          <div className="df">
            <div className="df-c !gap-2 w-45">
              <div className="df-c pr">
                <label className="label-trans" htmlFor="fullName">الاسم</label>
                <input
                  type="text"
                  id="fullName"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
              </div>
            </div>
            <div className="df-c !gap-2 w-45">
              <div className="df-c pr">
                <label className="label-trans" htmlFor="phone">رقم الهاتف</label>
                <input
                  type="text"
                  id="phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            </div>
          </div>

          {/* Image Drop Section */}
          <div className="df comment-user-img ai-stretch">
            <img
              className="!w-40"
              src={droppedImage ? URL.createObjectURL(droppedImage) : auth?.user.img ? process.env.REACT_APP_UPLOADS_DIR+auth?.user.img : "/img/default.png"}
              alt="user"
            />
            <div className="df-c jc-sb flex-1">
              <label
                htmlFor="image"
                className="drop-container"
                onDragOver={handleDragOver}
                onDrop={(e) => handleDrop(e, "image")}
              >
                <span className="rounded-icon"><CgAttachment /></span>
                <div className="text-center">
                  <span>انقر لتحميل</span> أو اسحب وأفلت <br />
                  SVG، JPEG، PNG أو GIF
                </div>
                <div className="df file-uploader">
                  <input
                    type="file"
                    id="image"
                    accept="image/*"
                    className="dnone"
                    onChange={(e) => handleFileChange(e, "image")}
                  />
                  {droppedImage && <p>{droppedImage.name}</p>}
                </div>
              </label>
            </div>
          </div>

          {/* Cover Drop Section */}
          <div className="df comment-user-img ai-stretch">
            <img
              className="!w-40 cover-edit"
              src={droppedCover ? URL.createObjectURL(droppedCover) : auth?.user.cover ? process.env.REACT_APP_UPLOADS_DIR+auth?.user.cover : "/img/banner.avif"}
              alt="cover"
            />
            <div className="df-c jc-sb flex-1">
              <label
                htmlFor="cover"
                className="drop-container"
                onDragOver={handleDragOver}
                onDrop={(e) => handleDrop(e, "cover")}
              >
                <span className="rounded-icon"><CgAttachment /></span>
                <div className="text-center">
                  <span>انقر لتحميل</span> أو اسحب وأفلت <br />
                  SVG، JPEG، PNG أو GIF
                </div>
                <div className="df file-uploader">
                  <input
                    type="file"
                    id="cover"
                    accept="image/*"
                    className="dnone"
                    onChange={(e) => handleFileChange(e, "cover")}
                  />
                  {droppedCover && <p>{droppedCover.name}</p>}
                </div>
              </label>
            </div>
          </div>
        </div>

        <div className="df header-btns w-fit mt-16 mr-auto">
          
          <motion.div
            className="details-btn df"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <button type="submit">تأكيد</button>
          </motion.div>
        </div>
      </form>
    </>
  );
}

export default EditInfo;